<template>
  <div>
    <div class="container-fluid card detail-list-card" v-for="detail in detailBody">
      <div class="detail-list-card">
        <div class="row detail-list-card-title">
            <div class="col-sm-11 height"><span class="title">{{ name(detail) }}</span></div>
            <div class="col-sm-1 height"><div class="print-container"><img src="../assets/print.svg" alt=""></div></div>
        </div>
        <detail-card :layout="layout" :detail-body="detail" :editable="editable" :keep-card-container="false"></detail-card>
      </div>
    </div>
  </div>

</template>
<script>
import DetailCard from './DetailCard';
export default{
    props:{
      detailBody: {default: () => [{}]},
      editable: {default: () => []},
      layout: {default: () => ({})}
    },
    methods: {
      name: function(detail){
        return detail.first_name + ' ' + detail.last_name;
      }
    },
    components: {
      DetailCard
    }
};
</script>
<style scoped>
  .detail-list-card{
    margin-bottom:10px;
  }
  .detail-list-card-title{
    line-height: 26px;
    margin-bottom: 15px;
    font-size: 22px;

  }
  .print-container{
    cursor: pointer;
    padding:4px;
    display: flex;
    background-color: #f4f4f4;
    width: 24px;
    float:right;
  }
  .print-container img{
    margin:auto;
  }
  .height{
    height: 26px;
  }
  span.title{
    color:grey;
    /*font-weight: bold;*/
  }
  div.card-section:last-child{

  }
</style>



// WEBPACK FOOTER //
// src/components/DetailListCard.vue